import React from 'react';
import { View, Text, TextInput, TouchableOpacity, Platform } from 'react-native';
import PlatformIcon from '../common/PlatformIcon';
import { ORANGE_ACTION } from '../../constants/colors';

interface Props {
  editMode: boolean;
  localTitle: string;
  onChangeTitle: (t: string) => void;
  titleFallback?: string;
  placeholderTitle?: string;
  localAddress?: string;
  onChangeAddress: (t: string) => void;
  onNavigate: () => void;
}

const PoiTitleAddressSection: React.FC<Props> = ({ editMode, localTitle, onChangeTitle, titleFallback, placeholderTitle, localAddress, onChangeAddress, onNavigate }) => {
  return (
    <View style={{ marginTop: 6, marginBottom: 8 }}>
      {editMode ? (
        <TextInput
          value={localTitle}
          onChangeText={onChangeTitle}
          placeholder={placeholderTitle || '請輸入名稱'}
          style={{ fontSize: 28, fontWeight: '800', color: '#111827', paddingVertical: Platform.OS === 'web' ? 4 : 2, borderWidth: 0 }}
        />
      ) : (
        <Text style={{ fontSize: 28, fontWeight: '800', color: '#111827' }}>{localTitle || titleFallback || ''}</Text>
      )}
      <View style={{ height: 2, backgroundColor: '#0B61D6', opacity: 0.16, marginTop: 8, marginBottom: 12 }} />

      <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 12 }}>
        <PlatformIcon name="location_on" size={18} color={ORANGE_ACTION} family="MaterialIcons" />
        {editMode ? (
          <TextInput
            value={typeof localAddress === 'string' ? localAddress : ''}
            onChangeText={onChangeAddress}
            placeholder="輸入地址"
            style={{ marginLeft: 8, color: '#8E8E93', fontSize: 15, paddingVertical: Platform.OS === 'web' ? 4 : 2, flex: 1, minWidth: 0 }}
          />
        ) : (
          <Text style={{ marginLeft: 8, color: '#8E8E93', fontSize: 15, flex: 1, minWidth: 0 }}>{typeof localAddress === 'string' ? localAddress : ''}</Text>
        )}
        <TouchableOpacity onPress={onNavigate} style={{ paddingHorizontal: 6, paddingVertical: 4, marginLeft: 6 }} accessibilityLabel="打開地圖導航">
          <PlatformIcon name="navigation" size={18} color={ORANGE_ACTION} />
        </TouchableOpacity>
      </View>
    </View>
  );
};

export default PoiTitleAddressSection;
